// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected[data-v-10938ced]{font-weight:700}li[data-v-10938ced]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
